export default "__VITE_ASSET__D90o8n6j__"